import type { InternalErrorResponse } from '@/services/transport/types'
import { TmBaseError } from '@/core/error/tmBaseError'

export class TmIncorrectContractError extends TmBaseError<InternalErrorResponse> {
  public name = 'TmIncorrectContractError'

  constructor(
    message = 'The response received from backend is different than expected. It may be a backend bug or you must fix this if the contract was changed.',
    response?: InternalErrorResponse,
  ) {
    super(message, response)
  }
}
